<template>
  <v-card v-if="fuente && destino">
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="closeDialog">
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>DEV-2 - Consolidación de Datos - {{ CA }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark flat @click="closeDialog">Cerrar</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <!-- <v-card-title 
      class="headline grey lighten-2"
      primary-title
    >
      Comparación de datos
    </v-card-title> -->
    <v-layout row wrap v-if="(destino && userPropietario !== 'nuevo') || true">
      <v-flex xs12>
        <v-card-text>
          <v-form>
            <v-layout wrap align-center>
              <template v-if="userPropietario != 'nuevo'">
                <v-flex xs5>
                  <h3>Datos Actuales</h3>
                </v-flex>
                <v-flex xs1 class="mx-3">
                  <h3></h3>
                </v-flex>
                <v-flex xs5>
                  <h3>Nuevos Datos</h3>
                </v-flex>
              </template>
              <template v-else>
                <v-flex xs12>
                  <h3 class="red--text">Consolidar datos sobre un Nuevo Propietario</h3>
                </v-flex>
              </template>
              <template v-if="userPropietario != 'nuevo'">
                <v-flex xs5>
                  <v-text-field
                    v-if="original"
                    v-model="original.private.nombre"
                    label="Nombre"
                    hint="Nombre"
                    disabled
                  ></v-text-field>
                </v-flex>
                <v-flex xs1 class="mx-3">
                  <v-btn block color="secondary" @click="changeValuePrivate('nombre')">
                    <v-icon>refresh</v-icon>
                  </v-btn>
                </v-flex>
              </template>
              <v-flex xs5>
                <v-text-field
                  :class="colored('nombre')"
                  v-model="destino.private.nombre"
                  label="Nombre"
                  hint="Nombre"
                ></v-text-field>
              </v-flex>

              <template v-if="userPropietario != 'nuevo'">
                <v-flex xs5>
                  <v-text-field
                    v-if="original"
                    v-model="original.private.apellido1"
                    label="Primer Apellido"
                    hint="Primer Apellido"
                    disabled
                  ></v-text-field>
                </v-flex>
                <v-flex xs1 class="mx-3">
                  <v-btn block color="secondary" @click="changeValuePrivate('apellido1')">
                    <v-icon>refresh</v-icon>
                  </v-btn>
                </v-flex>
              </template>
              <v-flex xs5>
                <v-text-field
                  :class="colored('apellido1')"
                  v-model="destino.private.apellido1"
                  label="Primer Apellido"
                  hint="Primer Apellido"
                ></v-text-field>
              </v-flex>

              <template v-if="userPropietario != 'nuevo'">
                <v-flex xs5>
                  <v-text-field
                    v-if="original"
                    v-model="original.private.apellido2"
                    label="Segundo Apellido"
                    hint="Segundo Apellido"
                    disabled
                  ></v-text-field>
                </v-flex>
                <v-flex xs1 class="mx-3">
                  <v-btn block color="secondary" @click="changeValuePrivate('apellido2')">
                    <v-icon>refresh</v-icon>
                  </v-btn>
                </v-flex>
              </template>
              <v-flex xs5>
                <v-text-field
                  :class="colored('apellido2')"
                  v-model="destino.private.apellido2"
                  label="Segundo Apellido"
                  hint="Segundo Apellido"
                ></v-text-field>
              </v-flex>

              <template v-if="userPropietario != 'nuevo'">
                <v-flex xs5>
                  <v-text-field
                    v-if="original"
                    v-model="original.private.nif"
                    label="NIF/NIE/DNI"
                    hint="NIF/NIE/DNI"
                    disabled
                  ></v-text-field>
                </v-flex>
                <v-flex xs1 class="mx-3">
                  <v-btn block color="secondary" @click="changeValuePrivate('nif')">
                    <v-icon>refresh</v-icon>
                  </v-btn>
                </v-flex>
              </template>
              <v-flex xs5>
                <v-text-field
                  :class="colored('nif')"
                  v-model="destino.private.nif"
                  label="NIF/NIE/DNI"
                  hint="NIF/NIE/DNI"
                ></v-text-field>
              </v-flex>

              <!-- Tlf1 -->
              <template v-if="userPropietario != 'nuevo'">
                <v-flex xs5>
                  <v-text-field
                    v-if="original"
                    v-model="original.private.tlf1"
                    label="Teléfono Principal"
                    hint="Teléfono Principal"
                    disabled
                  ></v-text-field>
                </v-flex>
                <v-flex xs1 class="mx-3">
                  <v-btn block color="secondary" @click="changeValuePrivate('tlf1')">
                    <v-icon>refresh</v-icon>
                  </v-btn>
                </v-flex>
              </template>
              <v-flex xs5>
                <v-text-field
                  :class="colored('tlf1')"
                  v-model="destino.private.tlf1"
                  label="Teléfono Principal"
                  hint="Teléfono Principal"
                ></v-text-field>
              </v-flex>


              <!-- Email -->
              <template v-if="userPropietario != 'nuevo'">
                <v-flex xs5>
                  <v-text-field
                    v-if="original"
                    v-model="original.admin.email"
                    label="Email"
                    hint="Email"
                    disabled
                  ></v-text-field>
                </v-flex>
                <v-flex xs1 class="mx-3">
                  <v-btn block color="secondary" @click="changeValuePrivate('email')">
                    <v-icon>refresh</v-icon>
                  </v-btn>
                </v-flex>
              </template>
              <v-flex xs5>
                <v-text-field
                  :class="colored('email')"
                  v-model="destino.admin.email"
                  label="Email"
                  hint="Email"
                ></v-text-field>
              </v-flex>

              <!-- Género -->
              <template v-if="CA === 'AN'">
                <template v-if="userPropietario != 'nuevo'">
                  <v-flex xs5>
                    <p>Género: <span>{{ original.private.genero ? original.private.genero === '1' ? 'Hombre' : 'Mujer' : ' - ' }}</span></p>
                  </v-flex>
                  <!-- <v-flex xs5>
                    <v-text-field
                      v-if="original"
                      v-model="original.private.genero"
                      label="Género"
                      hint="Género"
                      disabled
                    ></v-text-field>
                  </v-flex> -->
                  <v-flex xs1 class="mx-3">
                    <v-btn block color="secondary" @click="changeValuePrivate('genero')">
                      <v-icon>refresh</v-icon>
                    </v-btn>
                  </v-flex>
                </template>
                <v-flex xs5>
                  <p>Género: <span :class="colored('genero')">{{ destino.private.genero ? destino.private.genero === '1' ? 'Hombre' : 'Mujer' : ' - ' }}</span></p>
                </v-flex>
                <!-- <v-flex xs5>
                  <v-text-field
                    :class="colored('genero')"
                    v-model="destino.private.genero"
                    label="Género"
                    hint="Género"
                  ></v-text-field>
                </v-flex> -->
              </template>
              
              <!-- Fecha de Nacimiento -->
              <template v-if="userPropietario != 'nuevo'">
                <v-flex xs5>
                  <p>Fecha de Nacimiento: <span>{{ fechaNacimientoOriginal.string }}</span></p>
                </v-flex>
                <v-flex xs1 class="mx-3">
                  <v-btn block color="secondary" @click="changeValuePrivate('fechaNacimiento')">
                    <v-icon>refresh</v-icon>
                  </v-btn>
                </v-flex>
              </template>
              <v-flex xs5>
                <p>Fecha de Nacimiento: <span :class="colored('fechaNacimiento')">{{ fechaNacimientoDestino.string }}</span></p>
              </v-flex>

              <!-- Discapacidad -->
              <template v-if="userPropietario != 'nuevo'">
                <v-flex xs5>
                  <p>Discapacidad: <span>{{ original.private.discapacidad.isDiscapacidad ? 'SI' : 'NO' }}</span></p>
                </v-flex>
                <v-flex xs1 class="mx-3">
                  <v-btn block color="secondary" @click="changeValuePrivate('discapacidad')">
                    <v-icon>refresh</v-icon>
                  </v-btn>
                </v-flex>
              </template>
              <v-flex xs5>
                <p>Discapacidad: <span :class="colored('isDiscapacidad')">{{ destino.private.discapacidad.isDiscapacidad ? 'SI' : 'NO' }}</span></p>
              </v-flex>

              <template v-if="destino.private.discapacidad.isDiscapacidad">
                <template v-if="userPropietario != 'nuevo'">
                  <v-flex xs5>
                    <p>Documento: <span>{{ original.private.discapacidad.documentoDiscapacidad ? 'SI' : 'NO' }}</span></p>
                  </v-flex>
                  <v-flex xs1 class="mx-3">
                    <v-btn block color="secondary" @click="changeValuePrivate('documentoDiscapacidad')">
                      <v-icon>refresh</v-icon>
                    </v-btn>
                  </v-flex>
                </template>
                <v-flex xs5>
                  <p>Documento: <span :class="colored('documentoDiscapacidad')">{{ destino.private.discapacidad.documentoDiscapacidad ? 'SI' : 'NO' }}</span></p>
                </v-flex>

                <template v-if="userPropietario != 'nuevo'">
                  <v-flex xs5>
                    <p>Movilidad: <span>{{ original.private.discapacidad.movilidad ? 'SI' : 'NO' }}</span></p>
                  </v-flex>
                  <v-flex xs1 class="mx-3">
                    <v-btn block color="secondary" @click="changeValuePrivate('movilidad')">
                      <v-icon>refresh</v-icon>
                    </v-btn>
                  </v-flex>
                </template>
                <v-flex xs5>
                  <p>Movilidad: <span :class="colored('movilidad')">{{ destino.private.discapacidad.movilidad ? 'SI' : 'NO' }}</span></p>
                </v-flex>

                <template v-if="userPropietario != 'nuevo'">
                  <v-flex xs5>
                    <p>Grado: <span>{{ original.private.discapacidad.grado }}</span></p>
                  </v-flex>
                  <v-flex xs1 class="mx-3">
                    <v-btn block color="secondary" @click="changeValuePrivate('grado')">
                      <v-icon>refresh</v-icon>
                    </v-btn>
                  </v-flex>
                </template>
                <v-flex xs5>
                  <p>Grado: <span :class="colored('grado')">{{ destino.private.discapacidad.grado }}</span></p>
                </v-flex>

                <template v-if="userPropietario != 'nuevo'">                
                  <v-flex xs5>
                    <p>Tipo: <span>{{ original.private.discapacidad.tipo }}</span></p>
                  </v-flex>
                  <v-flex xs1 class="mx-3">
                    <v-btn block color="secondary" @click="changeValuePrivate('tipo')">
                      <v-icon>refresh</v-icon>
                    </v-btn>
                  </v-flex>
                </template>
                <v-flex xs5>
                  <p>Tipo: <span :class="colored('tipo')">{{ destino.private.discapacidad.tipo }}</span></p>
                </v-flex>
              </template>

              <!-- Notas -->
              <template v-if="userPropietario != 'nuevo'">
                <v-flex xs5>
                  <v-textarea
                    v-if="original"
                    v-model="original.private.notas"
                    label="Notas"
                    hint="Notas"
                    disabled
                  ></v-textarea>
                </v-flex>
                <v-flex xs1 class="mx-3">
                  <v-btn block color="secondary" @click="changeValuePrivate('notas')">
                    <v-icon>refresh</v-icon>
                  </v-btn>
                </v-flex>
              </template>
              <v-flex xs5>
                <v-textarea
                  :background-color="colored('notas')"
                  v-model="destino.private.notas"
                  label="Notas"
                  hint="Notas"
                ></v-textarea>
              </v-flex>

              
              <!-- Dirección -->
              <v-flex xs5 offset-xs5>
                <p>Dirección: <br>
                  <!-- <span class="grey--text">{{destino.private.datosFormulario.direccion.calle}}</span><br> -->
                  <span class="grey--text">Provincia: {{destino.private.datosFormulario.direccion.provincia || ' - '}}</span><br>
                  <span class="grey--text">Localidad: {{destino.private.datosFormulario.direccion.ciudad || ' - '}}</span>
                </p>
              </v-flex>
              <template v-if="userPropietario != 'nuevo'">
                <v-flex xs5>
                  <v-autocomplete
                    v-model="original.private.direccion.provincia"
                    :items="provinciaSelect"
                    :filter="customFilter"
                    item-text="text"
                    label="Provincia"
                    disabled
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs1 class="mx-3">
                  <v-btn block color="secondary" @click="changeValuePrivate('provincia')">
                    <v-icon>refresh</v-icon>
                  </v-btn>
                </v-flex>                   
              </template>
              <v-flex xs5>
                <v-autocomplete
                  :background-color="colored('provincia')"
                  v-model="destino.private.direccion.provincia"
                  :items="provinciaSelect"
                  :filter="customFilter"
                  item-text="text"
                  label="Provincia"
                  @change="changeProvincia"
                ></v-autocomplete>
              </v-flex>

              
              <template v-if="userPropietario != 'nuevo'">
                <v-flex xs5>
                  <v-autocomplete
                    v-model="original.private.direccion.localidad"
                    :items="municipioSelect"
                    :filter="customFilter"
                    item-text="text"
                    label="Localidad"
                    disabled
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs1 class="mx-3">
                  <v-btn block color="secondary" @click="changeValuePrivate('localidad')">
                    <v-icon>refresh</v-icon>
                  </v-btn>
                </v-flex>
              </template>
              <v-flex xs5>
                <v-autocomplete
                  :background-color="colored('localidad')"
                  v-model="destino.private.direccion.localidad"
                  :items="municipioSelect"
                  :filter="customFilter"
                  item-text="text"
                  label="Localidad"
                ></v-autocomplete>
              </v-flex>

              <template v-if="userPropietario != 'nuevo'">
                <v-flex xs5>
                  <v-text-field
                    v-if="original"
                    v-model="original.private.direccion.cp"
                    label="Código Postal"
                    hint="Código Postal"
                    disabled
                  ></v-text-field>
                </v-flex>
                <v-flex xs1 class="mx-3">
                  <v-btn block color="secondary" @click="changeValuePrivate('cp')">
                    <v-icon>refresh</v-icon>
                  </v-btn>
                </v-flex>
              </template>
              <v-flex xs5>
                <v-text-field
                  :class="colored('cp')"
                  v-model="destino.private.direccion.cp"
                  label="Código Postal"
                  hint="Código Postal"
                ></v-text-field>
              </v-flex>

              <template v-if="userPropietario != 'nuevo'">
                <v-flex xs5>
                  <v-text-field
                    v-if="original"
                    v-model="original.private.direccion.calle"
                    label="Calle"
                    hint="Calle"
                    disabled
                  ></v-text-field>
                </v-flex>
                <v-flex xs1 class="mx-3">
                  <v-btn block color="secondary" @click="changeValuePrivate('calle')">
                    <v-icon>refresh</v-icon>
                  </v-btn>
                </v-flex>
              </template>
              <v-flex xs5>
                <v-text-field
                  :class="colored('calle')"
                  v-model="destino.private.direccion.calle"
                  label="Calle"
                  hint="Calle"
                ></v-text-field>
              </v-flex>

              <!-- Control de Archivos y Firma -->
              <template v-if="userPropietario != 'nuevo' && files.length > 0">
                <v-flex xs12>
                  <h3>Control de Archivos y Firmas</h3>
                </v-flex>
                <v-flex xs5>
                  <h3>Datos Actuales</h3>
                </v-flex>
                <v-flex xs1 class="mx-3">
                  <h3></h3>
                </v-flex>
                <v-flex xs5>
                  <h3>Nuevos Datos</h3>
                </v-flex>

                <template v-for="(file, i) in files">
                  <v-flex xs12 :key="i">
                    <v-card>
                      <v-toolbar dark color="warning">
                        <v-toolbar-title v-if="file.code === 'firma'">Firma</v-toolbar-title>
                        <v-toolbar-title v-else>{{ file.data.description }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn :class="usarFile(file.code, file.name) ? 'danger' : 'success'" @click="noUsarArchivoFuente(file.code, file.name)">{{ usarFile(file.code, file.name) ? 'No usar' : 'Usar' }}</v-btn>
                      </v-toolbar>

                      <template v-if="usarFile(file.code, file.name)">
                        <v-layout row wrap>
                          <v-flex xs6>
                            {{ buscaFileOriginal(file.code) }}
                          </v-flex>
                          <v-flex xs6>
                            <img v-if="file.code === 'firma'" :src="file.data" >
                            <a v-else :href="file.data.downloadURL" target="_blank" rel="noopener noreferrer">{{ file.data.name }}</a>
                          </v-flex>
                        </v-layout>
                      </template>
                      <template v-else>
                        <v-flex xs12>
                          {{ buscaFileOriginal(file.code) }}
                        </v-flex>
                      </template>
                      <!-- <v-layout row wrap>
                        <v-flex xs6>
                          {{ buscaFileOriginal(file.code) }}
                        </v-flex>
                        <v-flex xs6 v-if="usarFile(file.code, file.name)">
                          <img v-if="file.code === 'firma'" :src="file.data" >
                          <a v-else :href="file.data.downloadURL" target="_blank" rel="noopener noreferrer">{{ file.data.name }}</a>
                        </v-flex>
                        <v-flex xs6 v-else>
                          {{ buscaFileOriginal(file.code) }}
                        </v-flex>  
                      </v-layout> -->
                    </v-card>
                  </v-flex>
                    <!-- <v-flex xs12>
                      {{ file.data.description }}
                    </v-flex>
                    <v-divider></v-divider>
                    <v-flex xs6>
                      {{ buscaFileOriginal(file.code) }}
                    </v-flex>
                    <v-flex xs6 offset-xs1>
                      <pre>{{ file }}</pre>
                      <a :href="file.data.downloadURL" target="_blank" rel="noopener noreferrer">{{ file.data.name }}</a>
                    </v-flex> -->
                  <!-- </v-flex> -->
                </template>
              </template>
              
              <!-- Guardar -->
              <template v-if="userPropietario != 'nuevo'">
                <v-flex xs7 offset-xs5>
                  <v-btn block color="primary" @click="saveData">Guardar y Consolidar Datos</v-btn>
                </v-flex>
              </template>
              <template v-else>
                <v-flex xs10>
                  <v-btn block color="primary" @click="saveData">Guardar y Consolidar Datos</v-btn>
                </v-flex>
              </template>

            </v-layout>
          </v-form>
          <!-- <p>Nombre:</p>
          <p>{{destino.data.private.nombre}}</p>
          <p>{{fuente.userBurbuja.propietarioBurbuja.pFisica.nombre}}</p> -->
        </v-card-text>
      </v-flex>
    </v-layout>

    <!-- <v-layout row wrap v-if="(destino && userPropietario === 'nuevo') && false">
      <v-flex xs12>
        <v-card-text>
          <h3>Agregar nuevo Registro</h3>
          <pre>{{destino}}</pre>
        </v-card-text>
      </v-flex>
    </v-layout> -->

    <v-card-text>
      <!-- <pre>{{filesNoUsar}}</pre> -->
      <!-- <pre>files: {{files}}</pre> -->
      <!-- <pre>Destino: {{destino.private.datosFormulario}}</pre> -->
      <!-- <pre>Original: {{original}}</pre>
      <pre>Fuente: {{fuente}}</pre> -->
      <!-- <pre>temportalDireccion: {{temportalDireccion}}</pre>
      <pre>Destino: {{destino}}</pre>
      <pre>Original: {{original}}</pre> -->
      <!-- <pre>refBurbuja: {{refBurbuja}}</pre>
      <pre>refPropietario: {{refPropietario}}</pre> -->
      <!-- <pre>userPropietario.idx: {{ userPropietario.idx }}</pre> -->
      <!-- <pre>userBurbuja: {{ userBurbuja }}</pre> -->
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="closeDialog">Cerrar</v-btn>
    </v-card-actions>
    
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import { functions } from "@/components/firebase.js";
const modelUser = {
  "admin": {
    "email": "",
    "isAdminFicas": false,
    "isGestor": false,
    "isTecnico": false,
    "isVerified": false,
    "level": 1,
    "noEnviarEmails": false,
    "rol": "Usuario",
    "username": "",
    "verificarEmail": true
  },
  "lastConnect": "",
  "private": {
    "datosFormulario": {},
    "apellido1": "",
    "apellido2": "",
    "direccion": {
        "calle": "",
        "cp": "",
        "localidad": null,
        "provincia": ""
    },
    "discapacidad": {
        "documentoDiscapacidad": false,
        "grado": 0,
        "isDiscapacidad": false,
        "movilidad": false,
        "tipo": false
    },
    "fechaNacimientoDia": "",
    "fechaNacimientoMes": "",
    "fechaNacimientoYear": "",
    "inmuebles": {},
    "nif": "",
    "nombre": "",
    "notas": "",
    "tlf": [],
    "tlf1": ""
  }
}
const modelCatastroUser = {
  "cuota" : "0",
  "discapacidad" : false,
  "empadronado" : false,
  "id" : "",
  "mayor65" : false,
  "padronStatusConocido" : 0,
  "tipo" : "0"
}
export default {
  props: ["userBurbuja", "userPropietario", "CA"],
  data() {
    return {
      fuente: null,
      destino: null,
      original: null,
      temportalDireccion: null,
      filesOriginal: [],
      filesNoUsar: [],
      files: []
    }
  },

  mounted() {
    console.log('mounted')
    this.reset()
    // this.newData()
    // this.fuente = Object.assign({}, this.burbujaUser)
    // this.destino = Object.assign({}, this.burbujaUser)
    // this.original = Object.assign({}, this.userPropietario)

    // this.destino = Object.assign({}, this.userPropietario)
    // this.dataPropietario = Object.assign({}, modelPropietario, this.propietario);
  },

  watch: {
    userBurbuja() {
      console.log('userBurbuja ha cambiado:')
      this.newData()
      // this.fuente = Object.assign({}, this.burbujaUser)
      // this.destino = Object.assign({}, this.burbujaUser)
    },

    userPropietario() {
      console.log('userPropietario ha cambiado:')
      this.newData()
      /* if (this.userPropietario === 'nuevo') {
        this.original = 'nuevo'
      } else {
        this.original = Object.assign({}, this.userPropietario)
      } */
    }
  },

  computed: {
    /* discapacidadBurbuja() {
      let result = {
        "documentoDiscapacidad": false,
        "grado": 0,
        "isDiscapacidad": false,
        "movilidad": false,
        "tipo": false
      }
      if (this.burbujaUser) {
        result = this.burbujaUser.pFisica.discapacidad
        resutl.isDiscapacidad = resutl.isDiscapacidad === '1' ? true : false
      }
      return result
    }, */

    /* filesOriginal_old() {
      if (!this.original || !this.original.private || !this.original.private.datosFormulario) {
        return []
      }
      return this.filesCheck(this.original.private.datosFormulario)
    }, */

    /**
     * files()
     * devuelve todos los archivos subidos desde el formulario de usuario
     */
    files_old() {
      return []
      /* if (!this.fuente) {
        return []
      }
      return this.filesCheck(this.fuente) */

      // 6844601UF8664S

      /* let result = []
      const filesData = [
        ["filesAlquiler", "Alquiler"],
        ["filesDiscapacidad", "Discapacidad"],
        ["filesEmpadronamiento", "Empadronamiento"],
        ["filesNifCif", "NIF/CIF"],
        ["filesPadron", "Padrón"],
        ["filesRenta", "Renta"],
        ["filesAlquilerAcuerdo", "Acuerdo"],
        ["filesAyudas", "Ayudas"],
        ["filesDeclaraResponsable", "Declaración"],
        ["filesDependencia", "Dependencia"],
        ["filesGrupoEspecial", "G.Especial"],
        ["filesRenta1", "Renta_1"],
        ["filesTgss", "TGSS"]
      ]

      filesData.forEach(element => {
        const data = this.filesArray(this.fuente[element[0]], element[1])
        if (data) {
          data.forEach(d => {
            result.push(d)
          })
        }
      })

      return result */

    },

    refBurbuja() {
      if (!this.userBurbuja) {
        return null
      }
      return {
        ref: this.userBurbuja.ref,
        idInmueble: this.userBurbuja.idInmueble,
        sessionUid: this.userBurbuja.userBurbuja.sessionUid
      }
    },

    refPropietario() {
      if (!this.userPropietario) {
        return null
      }
      const burbujaRef = this.refBurbuja ? this.refBurbuja.sessionUid : null
      const idx = this.userPropietario && this.userPropietario.idx ? this.userPropietario.idx : null
      return idx ? idx : burbujaRef
    },

    municipioSelect() {
      return this.$store.getters.getMunicipiosSelect;
    },
    provinciaSelect() {
      return this.$store.getters.getProvinciasSelect;
    },
    isMismaFecha() {
      if (!this.destino || !this.original) {
        return false
      }
      if (
        this.destino.private.fechaNacimientoDia === this.original.private.fechaNacimientoDia
        && this.destino.private.fechaNacimientoMes === this.original.private.fechaNacimientoMes
        && this.destino.private.fechaNacimientoYear === this.original.private.fechaNacimientoYear
      ) {
        return true
      }
      return false
    },

    fechaNacimientoOriginal() {
      if (!this.propietario) {
        return this.fechaCalc(null, null, null)
      }
      // const fecha = new Date(`${this.propietario.private.fechaNacimientoYear}-${this.propietario.private.fechaNacimientoMes}-${this.propietario.private.fechaNacimientoDia}`)
      return this.fechaCalc(this.propietario.private.fechaNacimientoDia, this.propietario.private.fechaNacimientoMes, this.propietario.private.fechaNacimientoYear)
      

      /* if (f.fecha) {
        return {
          string: fecha.toLocaleDateString(),
          fecha: fecha
        }
      }
      return {
        string: ' - ',
        fecha: false
      } */
    },

    fechaNacimientoBurbuja() {
      if (!this.burbujaUser || !this.burbujaUser.pFisica.fechaNacimiento) {
        return this.fechaCalc(null, null, null)
      }
      const fecha = new Date(this.burbujaUser.pFisica.fechaNacimiento)
      return {
        dia: fecha.getDate(),
        mes: fecha.getMonth() + 1,
        year: fecha.getFullYear(),
        string: fecha.toLocaleDateString(),
        fecha: fecha
      }
    },

    fechaNacimientoDestino() {
      if (!this.destino) {
        return this.fechaCalc(null, null, null)
      }
      return this.fechaCalc(this.destino.private.fechaNacimientoDia, this.destino.private.fechaNacimientoMes, this.destino.private.fechaNacimientoYear)
    },

    propietario() {
      if (this.userPropietario && this.userPropietario.data) {
        return this.userPropietario.data
      }
      return modelUser
    },

    burbujaUser() {
      if (this.userBurbuja && this.userBurbuja.userBurbuja.propietarioBurbuja) {
        let result = this.userBurbuja.userBurbuja.propietarioBurbuja
        result.pFisica.discapacidad = this.discapacidadCalc(result.pFisica.discapacidad)
        return result
      }
      return null
    }
  },

  methods: {
    ...mapActions(["saveUserConsolidated", "saveCatastroUserConsolidated", "saveUserFormConsolidated", "consolidaForm"]),

    restauraOriginal(code, url = null) {
      let datosFormulario = {}
      if (this.original && this.original.private && this.original.private.datosFormulario) {
        datosFormulario = Object.assign({}, this.original.private.datosFormulario)
      }
      const campo = datosFormulario[code] ? datosFormulario[code] : code === 'firma' ? '' : [];
      if (code === 'firma') {
        // Se trata de la firma
        this.destino.private.datosFormulario.firma = campo;
        return;
      }

      const datosEnDestino = this.destino.private.datosFormulario[code]; // Array
      if (!url || !datosEnDestino || datosEnDestino.length < 1) {
        console.log('Falta el campo <url> para comparar con <downloadURL>, o no existe el campo en destino');
        this.destino.private.datosFormulario[code] = campo;
        return;
      }
      let index = 0;
      datosEnDestino.forEach(element => {
        const downloadURL = element.downloadURL
        if (downloadURL === url) {
          this.destino.private.datosFormulario[code][index] = campo;
        }
      })

    },

    usarFile(code, name) {
      return this.filesNoUsar.indexOf(`${code}%${name}`) < 0;
    },

    noUsarArchivoFuente(code, name) {
      // console.log(`No usar el archivo ${code}:[${name}]`);
      if (this.usarFile(code, name)) {
        this.filesNoUsar.push(`${code}%${name}`);
        // this.filesNoUsar = this.filesNoUsar.filter(f => f !== `${code}_${name}`);
        return;
      }
      this.filesNoUsar = this.filesNoUsar.filter(f => f !== `${code}%${name}`);
      // this.filesNoUsar.push(`${code}_${name}`);

      // desti.private.datosFormulario
      /* if (!this.original || !this.original.private || !this.original.private.datosFormulario) {
        this.filesOriginal = []
      } else {
        this.filesOriginal = this.filesCheck(this.original.private.datosFormulario)
      } */
    },

    buscaFileOriginal(code) {
      // console.log(`Buscando fileOriginal <${code}>`)
      let result = ' <- Ningún archivo ->'
      if (!this.filesOriginal || this.filesOriginal.length < 1) {
        // console.log('No existen archivos originales')
        return result
      }
      const busqueda = this.filesOriginal.filter(i => i.code === code)
      if (!busqueda || !busqueda.length < 1) {
        // console.log('No encontrado este <code> en archivos originales')
        return result
      }
      result = ''
      busqueda.forEach( element => {
        if (code === 'firma') {
          result += ` ${element}`
        } else {
          result += ` ${element.data.downloadURL}`
        }
      })
      // console.log('encontrados originales: ', result)
      // console.log(this.filesOriginal)
      return result.trim()
    },

    filesCheck(datos) {
      if (!datos) {
        return []
      }
      let result = []

      const filesData = [
        ["firma", "Firma"],
        ["filesAlquiler", "Alquiler"],
        ["filesDiscapacidad", "Discapacidad"],
        ["filesEmpadronamiento", "Empadronamiento"],
        ["filesNifCif", "NIF/CIF"],
        ["filesPadron", "Padrón"],
        ["filesRenta", "Renta"],
        ["filesAlquilerAcuerdo", "Acuerdo"],
        ["filesAyudas", "Ayudas"],
        ["filesDeclaraResponsable", "Declaración"],
        ["filesDependencia", "Dependencia"],
        ["filesGrupoEspecial", "G.Especial"],
        ["filesRenta1", "Renta_1"],
        ["filesTgss", "TGSS"]
      ]

      filesData.forEach(element => {
        const data = this.filesArray(datos[element[0]], element[1], element[0])
        if (data) {
          data.forEach(d => {
            result.push(d)
          })
        }
      })

      return result

    },

    filesArray(files, name, code) {
      let result = []
      if (code === 'firma') {
        // console.log('Buscamos la firma');
        if (files) {
          // console.log(`Recibimos el dato como un ${typeof files} con ${files.length} caracteres`);
          result.push({
            name: name,
            code: code,
            data: files
          });
        }
      }
      if (files && Array.isArray(files) && files.length > 0) {
        let index = 0
        files.forEach(element => {
          index++
          result.push({
            name: `${name} #${index}`,
            code: code,
            data: element
          })
        });
      }
      return result.length > 0 ? result : null
    },

    calculaEdad(fechaNacimiento) {
      if (!fechaNacimiento) {
        return 0
      }
      const hoy = new Date();
      const cumpleanos = fechaNacimiento; //new Date(fechaNacimiento);
      let edad = hoy.getFullYear() - cumpleanos.getFullYear();
      const m = hoy.getMonth() - cumpleanos.getMonth();

      if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
          edad--;
      }

      return edad;
    },

    saveData() {
      if (!this.refPropietario) {
        console.log('No existe ningún usuario para consolidar')
        return
      }
      // console.log('Consolidando datos')
      // console.log(JSON.stringify(this.destino))

      // Catastro
      const empadronado = this.destino.private.datosFormulario.empadronado
      const fechaNaciemiento = this.fechaCalc(this.destino.private.fechaNacimientoDia, this.destino.private.fechaNacimientoMes, this.destino.private.fechaNacimientoYear).fecha
      
      let dataCatastro = Object.assign({}, modelCatastroUser)
      dataCatastro.id = this.refPropietario
      dataCatastro.cuota = this.destino.private.datosFormulario.relacionInmueble.propiedadPercent
      dataCatastro.tipo = this.destino.private.datosFormulario.relacionInmueble.tipo === '1' ? '0' : '1'
      dataCatastro.empadronado = empadronado === '1' ? true : false
      dataCatastro.padronStatusConocido = !!empadronado ? (empadronado === '1' ? 2 : 1) : 0
      dataCatastro.discapacidad = this.destino.private.discapacidad.isDiscapacidad ? this.destino.private.discapacidad : false
      dataCatastro.mayor65 = fechaNaciemiento ? this.calculaEdad(fechaNaciemiento) > 65 : false

      /**
       {
          "name": "Renta_1 #1",
          "code": "filesRenta1",
          "data": {
            "description": "renta autonómica",
            "descriptionCode": "filesRenta1",
            "downloadURL": "https://firebasestorage.googleapis.com/v0/b/app-users-cloud.appspot.com/o/users-forms%2F6844601UF8664S%2F28%2Fform-1571860008795-dbnz53pn9%2FMam%20Avis%20d'imp%C3%B4ts%202018.pdf?alt=media&token=9254d84c-2fae-473b-a98a-c88d12a0490e",
            "last_modified": "09/09/2018",
            "name": "Mam Avis d'impôts 2018.pdf",
            "size": 382134,
            "type": "application/pdf",
            "upload": 100
          }
        }
       */

      // users-forms
      /* const formUserConsolidated = {
        sessionUid: this.refBurbuja.sessionUid,
        refCat: this.refBurbuja.ref,
        ruta1: `usersConsolidated.${parseInt(this.refBurbuja.idInmueble)}.${this.refBurbuja.sessionUid}.updated_at`,
        data1: new Date(),
        ruta2: `usersConsolidated.${parseInt(this.refBurbuja.idInmueble)}.${this.refBurbuja.sessionUid}.userUid`,
        data2: this.refPropietario
      } */

      // Control de firma y archivos adjuntos.
      if (this.filesNoUsar.length > 0) {
        this.filesNoUsar.forEach(element => {
          // console.log(`eliminar el archivo ${element}`);
          const codeName = element.split('%')
          // console.log(codeName);
          const code = codeName[0];
          const name = codeName[1];
          if (code === 'firma') {
            // Cambio directo
            this.restauraOriginal('firma');
          } else {
            // Buscar archivo
            const url = this.files.filter(f => f.code === code && f.name === name)[0].data.downloadURL;
            this.restauraOriginal(code, url);
          }
          
          // separar código y nombre
          // console.log('');
          // this.destino.private.datosFormulario
        })
      }

      // console.log(JSON.stringify(this.destino.private.datosFormulario))

      // return;

      const datos = {
        idUser: this.refPropietario,
        userData: this.destino,
        refCat: this.refBurbuja.ref,
        refInmueble: this.refBurbuja.idInmueble,
        dataCatastro: dataCatastro,
        sessionUid: this.refBurbuja.sessionUid
      }

      /* console.log('DATOS:');
      console.log(JSON.stringify(datos));
      console.log('DESTINO:');
      console.log(JSON.stringify(this.destino));
      console.log('FUENTE:');
      console.log(JSON.stringify(this.fuente));
      console.log('ORIGINAL:');
      console.log(JSON.stringify(this.original));
      return; */
      this.consolidaForm(datos);

      /* const consolida = functions.httpsCallable("consolidaForm");
      consolida(datos)
        .then(data => {
          console.log(JSON.stringify(data));
          if (data.data.success) {
            console.log('Proceso terminado con éxito')
          } else {
            console.log("pasó algo...");
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error(error);
        }); */

      this.closeDialog();
    },

    saveData_Old() {
      if (!this.refPropietario) {
        console.log('No existe ningún usuario para consolidar')
        return
      }
      console.log('Consolidando datos')
      // console.log(JSON.stringify(this.destino))

      // users
      const dataUser = {
        uid: this.refPropietario,
        data: this.destino
      }
      // console.log(dataUser)
      this.saveUserConsolidated(dataUser)

      // Catastro
      const empadronado = this.destino.private.datosFormulario.empadronado
      const fechaNaciemiento = this.fechaCalc(this.destino.private.fechaNacimientoDia, this.destino.private.fechaNacimientoMes, this.destino.private.fechaNacimientoYear).fecha
      
      let dataCatastro = Object.assign({}, modelCatastroUser)
      dataCatastro.id = this.refPropietario
      dataCatastro.cuota = this.destino.private.datosFormulario.relacionInmueble.propiedadPercent
      dataCatastro.tipo = this.destino.private.datosFormulario.relacionInmueble.tipo === '1' ? '0' : '1'
      dataCatastro.empadronado = empadronado === '1' ? true : false
      dataCatastro.padronStatusConocido = !!empadronado ? (empadronado === '1' ? 2 : 1) : 0
      dataCatastro.discapacidad = this.destino.private.discapacidad.isDiscapacidad ? this.destino.private.discapacidad : false
      dataCatastro.mayor65 = fechaNaciemiento ? this.calculaEdad(fechaNaciemiento) > 65 : false

      const catastroData = {
        refCat: this.refBurbuja.ref,
        refInmueble: this.refBurbuja.idInmueble,
        refUser: this.refPropietario,
        action: 'update',
        datos: dataCatastro
      }

      this.saveCatastroUserConsolidated(catastroData)

      // users-forms
      const formUserConsolidated = {
        sessionUid: this.refBurbuja.sessionUid,
        refCat: this.refBurbuja.ref,
        ruta1: `usersConsolidated.${parseInt(this.refBurbuja.idInmueble)}.${this.refBurbuja.sessionUid}.updated_at`,
        data1: new Date(),
        ruta2: `usersConsolidated.${parseInt(this.refBurbuja.idInmueble)}.${this.refBurbuja.sessionUid}.userUid`,
        data2: this.refPropietario
      }
      // console.log(formUserConsolidated)
      this.saveUserFormConsolidated(formUserConsolidated)

      this.closeDialog();
    },

    isMismaDiscapacidad(campo) {
      if (!this.destino || !this.original) {
        return false
      }
      if (this.destino.private.discapacidad[campo] === this.original.private.discapacidad[campo]) {
        return true
      }
      return false
    },

    isMismaDir(campo) {
      if (!this.destino || !this.original) {
        return false
      }
      if (this.destino.private.direccion[campo] === this.original.private.direccion[campo]) {
        return true
      }
      return false
    },
    changeProvincia() {
      this.$store.dispatch(
        "setMunicipios",
        this.destino.private.direccion.provincia
      );
    },
    customFilter(item, queryText) {
      const textOne = item.text.toLowerCase();
      const searchText = queryText.toLowerCase();
      return textOne.indexOf(searchText) > -1;
    },
    discapacidadCalc(discapacidad) {
      let result = {
        "documentoDiscapacidad": false,
        "grado": 0,
        "isDiscapacidad": false,
        "movilidad": false,
        "tipo": false
      }
      if (discapacidad) {
        result = discapacidad
        result.isDiscapacidad = result.isDiscapacidad === '1' || result.isDiscapacidad === true ? true : false
      }
      return result
    },

    fechaCalc(dia, mes, year) {
      if (!dia || !mes || !year) {
        return {
          dia: "",
          mes: "",
          year: "",
          string: ' - ',
          fecha: false
        }
      }
      const fecha = new Date(`${year}-${mes}-${dia}`)
      return {
        dia: fecha.getDate(),
        mes: fecha.getMonth() + 1,
        year: fecha.getFullYear(),
        string: fecha.toLocaleDateString(),
        fecha: fecha
      }
    },

    changeValuePrivate(campo) {
      if (!this.original) {
        return
      }
      switch (campo) {
        case 'fechaNacimiento':
          if (this.isMismaFecha) {
            if (this.fechaNacimientoBurbuja.fecha) {
              this.destino.private.fechaNacimientoDia = this.fechaNacimientoBurbuja.dia
              this.destino.private.fechaNacimientoMes = this.fechaNacimientoBurbuja.mes
              this.destino.private.fechaNacimientoYear = this.fechaNacimientoBurbuja.year
            }
          } else {
            this.destino.private.fechaNacimientoDia = this.fechaNacimientoOriginal.dia
            this.destino.private.fechaNacimientoMes = this.fechaNacimientoOriginal.mes
            this.destino.private.fechaNacimientoYear = this.fechaNacimientoOriginal.year
          }
          break;
        
        case 'grado':
        case 'tipo':
        case 'movilidad':
        case 'documentoDiscapacidad':
          if (!this.isMismaDiscapacidad(campo)) {
            this.destino.private.discapacidad[campo] = this.original.private.discapacidad[campo]
            return
          }
          this.destino.private.discapacidad[campo] = this.burbujaUser.pFisica.discapacidad[campo]
          break;

        /* case 'provincia':
          if (!this.isMismaDir(campo)) {
            this.destino.private.direccion.provincia = this.original.private.direccion.provincia
            this.changeProvincia()
          } else {
            this.destino.private.direccion[campo] = this.burbujaUser.direccion[campo]
          }
          // if (this.destino.private.direccion.provincia != this.original.private.direccion.provincia) {
          //   this.destino.private.direccion.provincia = this.original.private.direccion.provincia
          //   this.changeProvincia()
          // }
          break; */
        case 'cp':
        case 'calle':
        case 'localidad':
        case 'provincia':
          if (!this.isMismaDir(campo)) {
            this.destino.private.direccion[campo] = this.original.private.direccion[campo]
            if (campo === 'provincia') {
              this.changeProvincia()
            }
            return
          }
          this.destino.private.direccion[campo] = this.burbujaUser.direccion[campo]
          break;

        /* case 'localidad':
          if (this.destino.private.direccion.ciudad != this.original.private.direccion.localidad) {
            this.destino.private.direccion.ciudad = this.original.private.direccion.localidad
          }
          break;

        case 'cp':
          if (this.destino.private.direccion.cp != this.original.private.direccion.cp) {
            this.destino.private.direccion.cp = this.original.private.direccion.cp
            return
          }
          this.destino.private.direccion.cp = this.burbujaUser.direccion.cp
          break;

        case 'calle':
          if (this.destino.private.direccion.calle != this.original.private.direccion.calle) {
            this.destino.private.direccion.calle = this.original.private.direccion.calle
            return
          }
          this.destino.private.direccion.calle = this.burbujaUser.direccion.calle
          break; */

        default:
          if (this.destino.private[campo] != this.original.private[campo]) {
            this.destino.private[campo] = this.original.private[campo]
            return
          }
          this.destino.private[campo] = this.burbujaUser.pFisica[campo]
          break;
      }
      
    },

    colored(campo) {
      if (this.userPropietario === 'nuevo') {
        return ''
      }
      if (!this.original) {
        return 'red lighten-4'
      }
      switch (campo) {
        case 'fechaNacimiento':
          if (this.isMismaFecha) {
            return 'teal lighten-4'
          }
          return 'red lighten-4'
          break;

        case 'cp':
        case 'calle':
        case 'provincia':
        case 'localidad':
          if (this.isMismaDir(campo)) {
            return 'teal lighten-4'
          }
          return 'red lighten-4'
          break;
        
        case 'grado':
        case 'tipo':
        case 'movilidad':
        case 'isDiscapacidad':
        case 'documentoDiscapacidad':
          if (this.isMismaDiscapacidad(campo)) {
            return 'teal lighten-4'
          }
          return 'red lighten-4'
          break;

        default:
          if (this.destino.private[campo] === this.original.private[campo]) {
            return 'teal lighten-4'
          }
          break;
      }
      return 'red lighten-4'
    },

    reset() {
      this.filesNoUsar = []
      this.fuente = null
      this.destino = null
      this.original = null
      this.temportalDireccion = null
    },

    check(data, campo) {
      if (data && data[campo]) {
        return data[campo]
      }
      return false
    },

    adminData(datos) {
      if (datos.calificacionJuridica === '1') {
        return datos.pFisica.email
      } else {
        return datos.pJuridica.email
      }
    },

    basicData(original, nuevo) {
      // Comprueba los datos básicos del perfil de usuario ("private")
      if (!original || !original.private || !nuevo) {
        return
      }
      let result = Object.assign({}, original.private)
      if (this.CA === 'AN' && !original.private.hasOwnProperty('genero')) {
        result.genero = false
      }
      result.direccion = Object.assign({}, original.private.direccion, nuevo.direccion)
      if (nuevo.calificacionJuridica === '1') {
        // Persona Física
        let datos = Object.assign({}, nuevo.pFisica)
        // delete datos.direccion
        const keys = Object.keys(result)
        for (let index = 0; index < keys.length; index++) {
          const key = keys[index]
          const newDato = this.check(datos, key)
          if (newDato) {
            result[key] = newDato
          }
        }
        if (this.fechaNacimientoBurbuja.fecha) {
          result.fechaNacimientoDia = this.fechaNacimientoBurbuja.dia
          result.fechaNacimientoMes = this.fechaNacimientoBurbuja.mes
          result.fechaNacimientoYear = this.fechaNacimientoBurbuja.year
        }
        // result.discapacidad = this.discapacidadBurbuja
      } else {
        let datos = Object.assign({}, nuevo.pJuridica)
        result.nombre = datos.razonSocial
        result.apellido1 = ""
        result.apellido2 = ""
        result.nif = datos.cif
        result.tlf1 = datos.apoderado.tlf1 ? datos.apoderado.tlf1 : result.tlf1
      }
      /* if (nuevo.direccion) {
        result.direccion
      } */
      result.datosFormulario = Object.assign({}, nuevo)
      return result
    },

    newData() {
      if (!this.burbujaUser) {
        return
      }
      this.fuente = Object.assign({}, this.burbujaUser)
      if (!this.userPropietario) {
        // console.error('Ningún propietario !!')
        return
      }
      if (this.userPropietario === 'nuevo') {
        // console.log('Es un propietario nuevo')
        this.original = Object.assign({}, modelUser)
        this.original.private.inmuebles = {}
        this.original.private.inmuebles[`${this.refBurbuja.ref}${this.refBurbuja.idInmueble}AA`] = {
          idInmueble: this.refBurbuja.idInmueble,
          refCatastral: this.refBurbuja.ref
        }
        // this.destino = Object.assign({}, this.burbujaUser)
      } else {
        // console.log('El propietario existe en la BD')
        this.original = Object.assign({}, this.userPropietario.data)
      }

      let desti = modelUser
      desti.admin.email = this.adminData(this.burbujaUser)
      desti.private = this.basicData(this.propietario, this.burbujaUser)
      delete desti.private.direccion.ciudad
      desti.private.datosFormulario = Object.assign({}, this.burbujaUser)
      this.destino = Object.assign({}, desti)
      this.destino.private.direccion.calle = desti.private.datosFormulario.direccion.calle
      this.destino.private.direccion.cp = desti.private.datosFormulario.direccion.cp
      this.temportalDireccion = Object.assign({}, desti.private.datosFormulario.direccion)

      // Archivos y firmas ya consolidados
      if (!this.original || !this.original.private || !this.original.private.datosFormulario) {
        this.filesOriginal = []
      } else {
        this.filesOriginal = this.filesCheck(this.original.private.datosFormulario)
      }

      // Archivos y firma en burbuja
      this.filesNoUsar = []
      if (!this.fuente) {
        this.files = []
        // this.filesDestino = []
      } else {
        this.files = this.filesCheck(this.fuente)
        // this.filesDestino = Object.assign({}, this.files)
      }
      /* if (this.CA === 'AN') {
        this.destino.private.genero
      } */

      /* console.log('ORIGINAL:')
      console.log(JSON.stringify(this.original))
      console.log('FUENTE:')
      console.log(JSON.stringify(this.fuente))
      console.log('DESTINO:')
      console.log(JSON.stringify(this.destino)) */
    },

    closeDialog() {
      this.$emit('closeConsolida')
    }
  }

}
</script>
